import React from 'react';

import Button from '../Button';

import './styles.scoped.css';

/**
 * Dialog shell for the BI Admin maintenance screens.
 *
 * The shared `Modal` renders its body inside a <p>, which cannot legally contain the form
 * controls, tables and textareas these dialogs need — so this is the second dialog shape
 * in the app rather than a duplicate of the first. Reach for `Modal` for a message and
 * this for a dialog that contains a form or a table.
 *
 * Lives in components/ rather than inside a feature because two features now use it
 * (SiteList and the TenStreet code tables); it started life in SiteList.
 *
 * Actions are a `buttons` array so each dialog decides its own set (Save/Delete/Cancel,
 * Import/Cancel, Close) without this component knowing about any of them.
 *
 * Imports `Button` directly rather than from the components barrel — a barrel import from
 * inside the barrel is a require cycle.
 */
const ModalShell = ({ title, subtitle, buttons = [], className = '', style = {}, children, ...rest }) => (
  <div className="modal-overlay" role="presentation" {...rest}>
    <div className={`modal-card ${className}`} style={style} role="dialog" aria-modal="true" aria-label={title}>
      <div className="modal-card-header">
        <h2 className="modal-card-title">{title}</h2>
        {!!subtitle && <p className="modal-card-subtitle">{subtitle}</p>}
      </div>
      <div className="modal-card-body">{children}</div>
      <div className="modal-card-footer">
        {buttons.map(button => (
          <Button
            key={button.text}
            variant={button.variant || 'primary'}
            text={button.text}
            onPress={button.onPress}
            disabled={button.disabled}
          />
        ))}
      </div>
    </div>
  </div>
);

export default ModalShell;
